import { deleteCrmTableData, fetchCrmTableData, postCrmTableData, updateCrmTableData } from "component/Common/API/api";
import NoramlButton from "component/Common/Button";
import { DynamicFormModal } from "component/Common/DynamicForm";
import InputBox from "component/Common/InputBox";
import Table from "component/Common/Table";
import DownloadList from "component/Reportings/ReportingDownload";
import { tabConfig } from "helpers/constant";
import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getbaseUrl } from "service/baserul";
import endpoints from "service/endpoints";

const CRMConfigurationComp = () => {
    const crmConfiguration = useSelector((state) =>
        state?.login?.permittedSections?.find(
            (d) => d.name === "CrmConfiguration"
        )
    );
    const [activeTab, setActiveTab] = useState("agentMapping");
    const [search, setSearch] = useState("")
    const [modalOpen, setModalOpen] = useState(false);
    const [formData, setFormData] = useState(null);
    const [data, setData] = useState({
        supportSkillMapping: [],
        agentMapping: [],
        eventCampaignMapping: [],
        distributionMapping: [],
        ozonetelUpload: []
    });
    const [activePage, setActivePage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);

    useEffect(() => {
        fetchTabData(activeTab);
    }, [activeTab, activePage, search]);

    const fetchTabData = async (tabKey) => {
        const payload = {
            page: activePage,
            limit: 10,
            search: search
        }
        try {

            console.log("Fetching data for tab:", tabKey);
            const responce = await fetchCrmTableData(payload, tabKey);
            console.log(responce, "res")



            setData((prev) => ({ ...prev, [tabKey]: responce?.list || [] }));
            setActivePage(responce?.pageMeta?.page)
            setTotalPage(responce?.pageMeta?.totalPages || 1);
        } catch (err) {
            console.error("Fetch error", err);
        }
    };
    const handleAdd = () => {
        setFormData(null);
        setModalOpen(true);
    };

    const handleEdit = (item) => {
        setFormData(item);
        setModalOpen(true);
    };

    const handleDelete = async (id) => {
        const res = await deleteCrmTableData(id, activeTab)
        if (res.status === 200) {
            fetchTabData(activeTab);
        };
    }

    const handleCreate = async (payload) => {

        const res = await postCrmTableData(payload, activeTab)
        setModalOpen(false);
        if (res.status === 200) {
            fetchTabData(activeTab);
        };
    }

    const handleSave = async (payload) => {
        const res = await updateCrmTableData(payload, activeTab)
        if (res.status === 200) {
            setModalOpen(false);
            setFormData(null);
            fetchTabData(activeTab);
        };
    }

    const handlePagination = (page) => {
        setActivePage(page);
    };
    let downloadExcelData = `${getbaseUrl("crm")}${endpoints.crmUpload.exportAgentMapping
        }?`
    if (search) downloadExcelData += `&search=${search}`

    return (
        <>
            <div className="bg-white p-4">
                <p className="fs-22 fw-600">CRM Configuration</p>

                <Tabs activeKey={activeTab} onSelect={(k) => {
                    setActiveTab(k);
                    setSearch("")
                    setActivePage(1); // reset page when tab changes
                }}>
                    {Object.keys(tabConfig).map((key) => (
                        <Tab eventKey={key} title={tabConfig[key].title} key={key}>
                            <div className="d-flex justify-content-between align-items-center m-3">
                                <p className="fs-17 fw-600 m-0">{tabConfig[key].title}</p>
                                <div className="mb-3 col-4">
                                    <InputBox.SearchBox
                                        name="search"
                                        placeholder={tabConfig[key].placeholder}
                                        onChange={(e) => setSearch(e.target.value)}
                                        value={search}
                                        className={``}
                                    />
                                </div>
                                <div className="col-1">
                                    {tabConfig[key].title == "Agent Mapping" && (
                                        <NoramlButton
                                            className="commonButton"
                                            label="Export CSV"
                                            onClick={() => {
                                                window.open(downloadExcelData, "_top")
                                            }}
                                        />
                                    )}
                                </div>
                                <div className="col-1">
                                    {crmConfiguration?.isEdit && (
                                        <NoramlButton
                                            className="commonButton"
                                            label="ADD"
                                            onClick={handleAdd}
                                        />
                                    )}

                                </div>
                            </div>
                            {typeof tabConfig[key].renderRow === "function" && (
                                <Table
                                    headers={
                                        crmConfiguration?.isEdit
                                            ? tabConfig[key].headers
                                            : tabConfig[key].headers.filter((h) => h.value !== "action")
                                    }
                                    isPagination={true}
                                    pageCount={totalPage}
                                    activePage={activePage}
                                    setactivePage={handlePagination}
                                >
                                    {data[key]?.map((item, index) =>

                                        tabConfig[key].renderRow(item, index, activePage, handleEdit, handleDelete, crmConfiguration?.isEdit)
                                    )}
                                </Table>
                            )}
                        </Tab>
                    ))}
                </Tabs>
            </div>


            <DynamicFormModal
                show={modalOpen}
                onClose={() => setModalOpen(false)}
                onSave={handleSave}
                onCreate={handleCreate}
                formFields={tabConfig[activeTab].formFields}
                initialData={formData}
                isEdit={Boolean(formData)}
            />

        </>
    );
};

export default CRMConfigurationComp;